import { render, staticRenderFns } from "./freightPriceCalculator.vue?vue&type=template&id=51726872&scoped=true"
import script from "./freightPriceCalculator.vue?vue&type=script&lang=js"
export * from "./freightPriceCalculator.vue?vue&type=script&lang=js"
import style0 from "./freightPriceCalculator.vue?vue&type=style&index=0&id=51726872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51726872",
  null
  
)

export default component.exports